import axios from "axios";

export const EXECUTIVE_GOVERNANCE_SUMMARY_URL =
  "/api/digital-risk/executive-dashboard/governance-summary/";

export async function fetchExecutiveGovernanceSummary() {
  const { data } = await axios.get(EXECUTIVE_GOVERNANCE_SUMMARY_URL);
  return data;
}
